<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields" :permission="permission" :searchs="[]" ref="table"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "UserTemplate",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'userTemplate:add',
                    update: 'userTemplate:update',
                    delete: 'userTemplate:delete',
                    deleteBatch: 'userTemplate:deleteBatch'
                },
                url: {
                    get: '/userTemplate/listByCondition',
                    add: '/userTemplate/add',
                    update: '/userTemplate/update',
                    delete: '/userTemplate/delete',
                    delete_batch: '/userTemplate/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                }, {
                    field: 'name',
                    label: '模板名称',
                    show: true,
                    width: '',
                }, {
                    field: 'sendMode',
                    label: '派单模式',
                    show: {
                        type: 'select'
                    },
                    selectData: [{
                        id: 1,
                        name: '比例模式'
                    }, {
                        id: 2,
                        name: '金额模式'
                    }],
                    width: '',
                }, {
                    field: 'orderNum',
                    label: '单数',
                    show: true,
                    width: '',
                }, {
                    field: 'reward',
                    label: '抢单奖励',
                    show: true,
                    width: '',
                }, {
                    field: 'earningMode',
                    label: '返佣模式',
                    show: {
                        type: 'select',
                    },
                    selectData:[{
                        id: 1,
                        name: '单商品提交后返佣'
                    },{
                        id: 2,
                        name: '单任务内所有商品提交返佣',
                    }],
                    width: '',
                }, {
                    field: 'principalMode',
                    label: '返本模式',
                    show: {
                        type: 'select',
                    },
                    selectData:[{
                        id: 1,
                        name: '单商品提交后返本',
                    },{
                        id: 2,
                        name: '单任务内所有商品提交返本',
                    }],
                    width: '',
                }, {
                    field: 'taskNum',
                    label: '任务次数',
                    show: true,
                    width: '',
                }, {
                    field: 'sendRatio',
                    label: '派单比例',
                    show: true,
                    width: '',
                }, {
                    field: 'money',
                    label: '派单金额',
                    show: true,
                    width: '',
                }, {
                    field: 'earningRatio',
                    label: '佣金比例',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加模板',
                    updateTitle: '修改模板',
                    labelWidth: '90px',
                    model: [{
                        field: 'name',
                        label: '模板名称：',
                        type: 'input',
                        placeholder: '模板名称',
                        rules:[{
                            message: '请输入模板名称', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'sendMode',
                        label: '派单模式：',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '比例模式'
                        }, {
                            id: 2,
                            name: '金额模式'
                        }],
                        placeholder: '派单模式',
                        rules:[{
                            message: '请选择派单模式', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'orderNum',
                        label: '单数：',
                        type: 'input',
                        placeholder: '单数',
                        rules:[{
                            message: '请输入单数', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                        tip: '这里的单数，指的是有几个大的订单，然后每个大订单里面有多个商品（小订单），所以这个单数的概念不要误解为商品数量',
                    }, {
                        field: 'reward',
                        label: '抢单奖励：',
                        type: 'input',
                        placeholder: '抢单奖励',
                        rules:[{
                            message: '请输入抢单奖励', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                        tip: '填写规则：\n' +
                            '抢单奖励的数值用 阿拉伯数值填写\n' +
                            '每个大订单对应的抢单奖励金额之间用 , 分号隔开\n' +
                            '例如 10,20,100 表示完成第1个大订单奖励10金币，第2个大订单奖励20金币，第3个大订单奖励100金币\n' +
                            '注意： 逗号的数量必须与单数一致，如果不奖励，也要用 0 去设置'
                    },{
                        field: 'earningMode',
                        label: '返佣模式：',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '单商品提交后返佣'
                        }, {
                            id: 2,
                            name: '单任务内所有商品提交返佣'
                        }],
                        placeholder: '返佣模式',
                        rules:[{
                            message: '请选择返佣模式', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'principalMode',
                        label: '返本模式：',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '单商品提交后返本'
                        }, {
                            id: 2,
                            name: '单任务内所有商品提交返本'
                        }],
                        placeholder: '返本模式',
                        rules:[{
                            message: '请选择返本模式', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'taskNum',
                        label: '任务次数：',
                        type: 'input',
                        placeholder: '任务次数',
                        rules:[{
                            message: '请输入任务次数', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                        tip: '任务次数指的是该分组的会员可以抢多少轮的单数，例如单数为2，任务次数为2，则表示会员可以抢单 2*2 = 4次'
                    }, {
                        field: 'sendRatio',
                        label: '派单比例：',
                        type: 'input',
                        placeholder: '派单比例',
                        rules:[{
                            message: '请输入派单比例', trigger: 'blur', required: this.$refs.table
                        }],
                        add: true,
                        update: true,
                        tip: '填写规则：\n' +
                            '有几个单数，就用 [ ] 符号扩起来（用英文分号隔开），括号内填写每个订单的商品金额比例\n' +
                            '例如填写：[0.5,0.2,0.3];[0.4,0.2,0.5]\n' +
                            '表示单数为2，第1单的商品金额比例为50%-20%-30%\n' +
                            '第2单的商品金额比例为40%-20%-50%'
                    }, {
                        field: 'money',
                        label: '派单金额：',
                        type: 'input',
                        placeholder: '派单金额',
                        rules:[{
                            message: '请输入派单金额', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                        tip: '填写规则：\n' +
                            '有几个单数，就用 [ ] 符号扩起来（用英文分号隔开），括号内填写每个订单的商品金额\n' +
                            '例如填写：[500,200,300];[400,200,500]\n' +
                            '表示单数为2，第1单的商品金额为500-200-300\n' +
                            '第2单的商品金额为400-200-500'
                    }, {
                        field: 'earningRatio',
                        label: '佣金比例：',
                        type: 'money',
                        placeholder: '佣金比例',
                        rules:[{
                            message: '请输入佣金比例', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
